// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"431":"957da21d","986":"50395243"}[chunkId] + ".chunk.js";
};